@let sessionReplicationState = this.sessionReplicationState();
@let sessionReplicationStateError = this.sessionReplicationStateError();

@if (sessionReplicationState && !sessionReplicationStateError) {
	@switch (sessionReplicationState.type) {
		@case (ReplicationStateType.NotFound) {
			<div class="statusTag {{ SimStatusPalette.inactive }}">
				<mat-icon fontIcon="fa-user-clock" fontSet="fas" />
				{{ T.REPLICATION_STATE_NOT_REPLICATED | translate }}
			</div>
		}
		@case (ReplicationStateType.Failed) {
			<div class="statusTag {{ SimStatusPalette.error }}">
				<mat-icon fontIcon="fa-user-clock" fontSet="fas" />
				{{ T.REPLICATION_STATE_REPLICATION_FAILED | translate }}
			</div>
		}
		@case (ReplicationStateType.Pending) {
			<div class="statusTag {{ SimStatusPalette.busy }}">
				<mat-icon fontIcon="fa-user-clock" fontSet="fas" />
				{{ T.REPLICATION_STATE_REPLICATION_IN_PROGRESS | translate }}
			</div>
		}
		@case (ReplicationStateType.Ready) {
			<div class="statusTag {{ SimStatusPalette.success }}">
				<mat-icon fontIcon="fa-user-clock" fontSet="fas" />
				@if (sessionReplicationState.accessibleFrom && sessionReplicationState.accessibleUntil) {
					{{ T.REPLICATION_STATE_SUCCESS_PUBLISHED | translate }}
					{{ sessionReplicationState.accessibleFrom | date: (T.DATE_FORMAT_LONG | translate) :'': translate.currentLang }}
					-
					{{ sessionReplicationState.accessibleUntil | date: (T.DATE_FORMAT_LONG | translate) :'': translate.currentLang }}
				} @else {
					{{ T.REPLICATION_STATE_SUCCESS_REPLICATED | translate }}
				}
			</div>
		}
	}
} @else if (sessionReplicationStateError) {
	<div class="statusTag {{ SimStatusPalette.error }}">
		<mat-icon fontIcon="fa-user-clock" fontSet="fas" />
		{{ sessionReplicationStateError | translate }}
	</div>
} @else {
	<div class="statusTag {{ SimStatusPalette.busy }}">
		<mat-icon class="fa-spin" fontIcon="fa-spinner" fontSet="fas" />
		{{ T.REPLICATION_STATE_CHECKING_STATE | translate }}
	</div>
}
